// extracted by mini-css-extract-plugin
export default {"container":"SP-z","title":"TP-z","link":"UP-z"};